import React, {
  ReactNode, useMemo, useState,
} from 'react';
import { AngledArrowInCircleFilled } from './Arrows';
import { useIsVisible } from "../hooks";

const classNames = require('html-classnames');

export enum ButtonModes {
  primary,
  secondary,
  gray,
  contrast,
}
export interface ButtonProps {
  url?: string
  newWindow?: boolean
  mode: ButtonModes,
  withBigEffect?: boolean,
  isButton?: boolean,
  children: ReactNode,
  color?: string,
  [x: string]: any,
}

// eslint-disable-next-line jsx-a11y/anchor-has-content
const A = (props: any, ref: any) => (<a {...props} ref={ref} />);
// eslint-disable-next-line react/button-has-type
const B = (props: any, ref: any) => (<button {...props} ref={ref} />);

export const Button: React.FC<ButtonProps> = ({
  url,
  newWindow = false,
  mode,
  withBigEffect,
  isButton = false,
  children,
  color,
  ...rest
}) => {
  // TODO: when url is # make nicer window.scrollTo with smooth behaviour (native!)
  const [buttonNode, setButtonNode] = useState(null);
  const isVisible = useIsVisible(buttonNode);
  const className = classNames('button', {
    '--primary': mode === ButtonModes.primary,
    '--gray': mode === ButtonModes.gray,
    '--contrast': mode === ButtonModes.contrast,
    '--no-border': mode === ButtonModes.gray,
    '--big-effect': withBigEffect && !!isVisible,
    '--big-effect-reverse': withBigEffect && !isVisible && typeof isVisible !== 'undefined',
  });

  const rawProps = newWindow ? {
    target: '_blank',
    rel: 'noreferrer',
  } : {};

  const Component = useMemo(() => React.forwardRef(isButton ? B : A), [isButton]);

  return (
    <Component
      href={url}
      className={className}
      ref={setButtonNode}
      {...rawProps}
      {...rest}
    >
      <span
        className="button__text"
        style={
          color && mode === ButtonModes.primary
            ? { background: color, boxShadow: `0 0 0 4px ${color}` }
            : { color }
        }
      >
        {children}
      </span>
      {mode !== ButtonModes.gray && <span className="button__ribbon" style={{ backgroundColor: color, opacity: color ? 0.1 : 1 }} />}
    </Component>
  );
};

interface RedirectionButtonProps {
  arrowColor?: string,
  color: string,
  text: string,
  url: string,
}

export const RedirectionButton: React.FC<RedirectionButtonProps> = ({
  arrowColor,
  color,
  text,
  url,
}: RedirectionButtonProps) => (
  <div className="pillar-redirection">
    <Button
      mode={ButtonModes.secondary}
      url={url}
      color={color}
    >
      <div className="pillar-redirection__button_content">
        <span className="pillar-redirection__button_content_text">{text}</span>
        <AngledArrowInCircleFilled color={color} arrowColor={arrowColor} />
      </div>
    </Button>
  </div>
);
